import { render } from "./AddPermission.vue?vue&type=template&id=9e5d538c"
import script from "./AddPermission.vue?vue&type=script&lang=js"
export * from "./AddPermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__